import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPatchAdminCollection_points_collectionPointId = z.any()
export type TagsPatchAdminCollection_points_collectionPointId = z.infer<typeof tagsPatchAdminCollection_points_collectionPointId>

export const paramsPatchAdminCollection_points_collectionPointId = z.object({ "collectionPointId": z.string() })
export type ParamsPatchAdminCollection_points_collectionPointId = z.infer<typeof paramsPatchAdminCollection_points_collectionPointId>

export const bodyPatchAdminCollection_points_collectionPointId = z.object({ "name": z.string().optional(), "identifier": z.string().optional(), "type": z.union([z.literal("electricity"), z.literal("gas"), z.literal("water"), z.literal("coal"), z.literal("heat"), z.literal("other")]).optional() })
export type BodyPatchAdminCollection_points_collectionPointId = z.infer<typeof bodyPatchAdminCollection_points_collectionPointId>

export const responsePatchAdminCollection_points_collectionPointId = z.object({ "payload": z.object({ "id": z.string().max(191), "buildingId": z.string().max(255), "name": z.string().max(255), "type": z.union([z.literal("electricity"), z.literal("gas"), z.literal("water"), z.literal("coal"), z.literal("heat"), z.literal("other")]), "identifier": z.string().max(255), "customType": z.union([z.string().max(100), z.null()]), "supplier": z.union([z.string().max(255), z.null()]), "price": z.union([z.string(), z.null()]), "distributionRate": z.union([z.string().max(50), z.null()]), "breaker": z.union([z.string().max(10), z.null()]), "singleRateTariff": z.boolean(), "meterCodes": z.union([z.union([z.union([z.string(), z.number(), z.boolean(), z.null()]), z.array(z.any()), z.record(z.any()).superRefine((value, ctx) => {
for (const key in value) {
if (key.match(new RegExp("^(.*)$"))) {
const result = z.any().safeParse(value[key])
if (!result.success) {
ctx.addIssue({
          path: [...ctx.path, key],
          code: 'custom',
          message: `Invalid input: Key matching regex /${key}/ must match schema`,
          params: {
            issues: result.error.issues
          }
        })
}
}
}
})]), z.null()]), "gasCalorificValue": z.union([z.string(), z.null()]), "gasVolumeCoefficient": z.union([z.string(), z.null()]), "consumptionReminderEnabled": z.boolean(), "consumptionReminderStartDate": z.union([z.string(), z.null()]), "consumptionReminderFrequency": z.union([z.literal("weekly"), z.literal("monthly"), z.literal("yearly")]), "order": z.string(), "createdAt": z.string(), "updatedAt": z.string(), "deletedAt": z.union([z.string(), z.null()]) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePatchAdminCollection_points_collectionPointId = z.infer<typeof responsePatchAdminCollection_points_collectionPointId>

interface IPatchAdminCollection_points_collectionPointId extends BaseMethodType {
  tags: TagsPatchAdminCollection_points_collectionPointId,
  params: ParamsPatchAdminCollection_points_collectionPointId,
  body: BodyPatchAdminCollection_points_collectionPointId,
  response: ResponsePatchAdminCollection_points_collectionPointId
}
export const tagsDeleteAdminCollection_points_collectionPointId = z.any()
export type TagsDeleteAdminCollection_points_collectionPointId = z.infer<typeof tagsDeleteAdminCollection_points_collectionPointId>

export const paramsDeleteAdminCollection_points_collectionPointId = z.object({ "collectionPointId": z.string() })
export type ParamsDeleteAdminCollection_points_collectionPointId = z.infer<typeof paramsDeleteAdminCollection_points_collectionPointId>

export const responseDeleteAdminCollection_points_collectionPointId = z.any()
export type ResponseDeleteAdminCollection_points_collectionPointId = z.infer<typeof responseDeleteAdminCollection_points_collectionPointId>

interface IDeleteAdminCollection_points_collectionPointId extends BaseMethodType {
  tags: TagsDeleteAdminCollection_points_collectionPointId,
  params: ParamsDeleteAdminCollection_points_collectionPointId,
  response: ResponseDeleteAdminCollection_points_collectionPointId
}
export const URL = '/admin/collection-points/:collectionPointId'
export const validation = {
  patch: {
    tags: tagsPatchAdminCollection_points_collectionPointId,
    params: paramsPatchAdminCollection_points_collectionPointId,
    body: bodyPatchAdminCollection_points_collectionPointId,
    response: responsePatchAdminCollection_points_collectionPointId
  },
  delete: {
    tags: tagsDeleteAdminCollection_points_collectionPointId,
    params: paramsDeleteAdminCollection_points_collectionPointId,
    response: responseDeleteAdminCollection_points_collectionPointId
  }
}
export interface AdminCollection_points_collectionPointId extends BaseRouteType {
  patch: IPatchAdminCollection_points_collectionPointId,
  delete: IDeleteAdminCollection_points_collectionPointId
}